import { bool, object, string } from "prop-types";
import cx from "classnames";

import StoryMetadata from "../StoryMetadata/StoryMetadata.jsx";
import Picture from "../Picture/Picture.jsx";
import Button from "../Button/Button.jsx";
import Icon from "../Icon/Icon.jsx";

// exported to use in storyListing
export const propTypes = {
  title: string.isRequired,
  description: string,
  author: string,
  url: string.isRequired,
  displayDate: string,
  date: string,
  picture: object, // Picture will validate
  small: bool,
  // If buttonText passed, a button will be visible.
  // If not, the entire card will be clickable
  buttonText: string,
};

const StoryPromo = (props) => {
  const {
    title,
    description,
    date,
    displayDate,
    author,
    picture,
    url,
    small,
    buttonText,
  } = props;

  return (
    <div
      className={cx("story-promo", {
        "story-promo--small": small,
      })}
    >
      {picture && (
        <div className="story-promo__picture-container">
          <Picture {...picture} />
        </div>
      )}
      {buttonText ? (
        <span className="story-promo__title">{title}</span>
      ) : (
        <a href={url} className="story-promo__title">
          {title}
        </a>
      )}
      {description && (
        <div className="story-promo__description">{description}</div>
      )}
      <div className="story-promo__metadata">
        <StoryMetadata
          date={date}
          displayDate={displayDate}
          authors={[author]}
        />
      </div>

      {buttonText && (
        <div className="story-promo__button">
          <Button
            as="a"
            className="btn btn--primary"
            href={url}
            icon={<Icon iconName="arrow-right" />}
          >
            {buttonText}
          </Button>
        </div>
      )}
    </div>
  );
};

StoryPromo.propTypes = propTypes;
export default StoryPromo;
